import React from "react";
import { Route, Router, Switch } from "wouter";
import UserHomePage from "../user/userScreens/homePage";
import UserLogin from "../user/userScreens/auth/userLogin";
import ForgotPassword from "../user/userScreens/auth/forgotPassword";
import Cart from "../user/userScreens/cart/cart";
import DealerResetPassword from "../user/userScreens/auth/resetPassword";
import OrderList from "../user/userScreens/orders/orderList";
import OrderRequestList from "../user/userScreens/orders/orderRequestsList";
import DealerOrderDetailsPage from "../user/userScreens/orders/orderDetails";
import MyAccount from "../user/userScreens/myAccount";
import About from "../user/userScreens/extra/about";
import TermsAndConditions from "../user/userScreens/extra/termsConditions";
import PrivacyPolicy from "../user/userScreens/extra/privacyPolicy";
import RefundPolicy from "../user/userScreens/extra/refundPolicy";
import ShippingPolicy from "../user/userScreens/extra/shippingPolicy";
import ContactUs from "../user/userScreens/extra/contactUs";

const ErrorScreen = React.lazy(() => import("../404"));

const UserRoutes = () => {
  return (
    <Router>
      <React.Suspense>
        <Switch>
          <Route path="/" component={UserHomePage} />
          <Route path="/login/dealer" component={UserLogin} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/cart" component={Cart} />
          <Route path="/reset-password" component={DealerResetPassword} />
          <Route path="/orders" component={OrderList} />
          <Route path="/order-requests" component={OrderRequestList} />
          <Route path="/order-details" component={DealerOrderDetailsPage} />
          <Route path="/myaccount" component={MyAccount} />
          <Route path="/about" component={About} />
          <Route path="/terms-and-conditions" component={TermsAndConditions} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/refund-policy" component={RefundPolicy} />
          <Route path="/shipping-policy" component={ShippingPolicy} />
          <Route path="/contact-us" component={ContactUs} />
          <Route component={ErrorScreen} />
        </Switch>
      </React.Suspense>
    </Router>
  );
};

export default UserRoutes;
